<template>
    <div v-if="isLoading" class="loading-overlay">
        <p>Carregando dados...</p>
    </div>

    <div v-if="msgAlerta" class="info-alert row-space">
        {{ msgAlerta }}
    </div>

    <!-- CABEÇALHO DO MODELO -->
    <div class="form-edit-page row-space">
        <div class="row row-space">
            <div class="form-item-char05">
                <label class="label-caption">Código</label>
                <div class="field-label field-label-end">
                    {{ Funcoes.formatInteger(objEdicao.id) }}
                </div>
            </div>

            <div class="form-item-char15">
                <label class="label-caption" for="cdmodelo">Código Modelo</label>
                <input type="text" v-model="objEdicao.cdmodelo" id="cdmodelo" maxlength="50" />
            </div>

            <div class="form-item-char15">
                <label class="label-caption" for="nmrelatorio">Relatório</label>
                <input type="text" v-model="objEdicao.nmrelatorio" id="nmrelatorio" maxlength="50" />
            </div>

            <div class="form-item-char15">
                <label class="label-caption" for="protocolo_prefixo">Prefixo Protocolo</label>
                <input type="text" v-model="objEdicao.protocolo_prefixo" id="protocolo_prefixo" maxlength="20" />
            </div>

            <div class="form-item">
                <label class="label-caption" for="nmepdocmodelo">Nome Modelo</label>
                <input type="text" v-model="objEdicao.nmepdocmodelo" id="nmepdocmodelo" maxlength="100" />
            </div>

            <button class="btn-small" @click="showModalPerfil=true">Perfil</button>
            <button class="btn-small" @click="salvarDados">Salvar</button>
            <button class="btn-small" @click="closeForm">Voltar</button>
        </div>

        <div class="row row-space">
            <div class="form-item-char30">
                <EpMenuDocSelect v-model:idSelecionado="objEdicao.idepmenudoc" />
            </div>

            <div class="form-item">
                <label class="label-caption" for="nmmenu">Nome Menu</label>
                <input type="text" v-model="objEdicao.nmmenu" id="nmmenu" maxlength="100" />
            </div>

            <div class="form-item-char15">
                <label class="label-caption">Ativo</label>
                <select v-model="objEdicao.ativo">
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                </select>
            </div>

            <div class="form-item-char15">
                <label class="label-caption">Acesso App</label>
                <select v-model="objEdicao.ckapp">
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                </select>
            </div>

            <div class="form-item-char15">
                <label class="label-caption">Acesso Web</label>
                <select v-model="objEdicao.ckweb">
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                </select>
            </div>

            <div class="form-item-char15">
                <label class="label-caption">Estabelecimento</label>
                <select v-model="objEdicao.ckestabelecimento">
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                    <option value="O">Opcional</option>
                </select>
            </div>

            <div class="form-item-char15">
                <label class="label-caption">S.I.M.</label>
                <select v-model="objEdicao.cksim">
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                    <option value="O">Opcional</option>
                </select>
            </div>

            <div class="form-item-char15">
                <label class="label-caption">Permitir Anexos</label>
                <select v-model="objEdicao.ckanexo">
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                </select>
            </div>
        </div>

        <div class="row row-space">
            <div class="form-item">
                <textarea
                    v-model="objEdicao.informacoes"
                    id="informacoes"
                    maxlength="3000"
                    rows="3"
                    style="resize: none;"
                />
            </div>
        </div>
    </div>


    <div v-if="objEdicao.id">
        <!-- ABAS DO MODELO -->
        <div class="form-panel row-space">
            <div class="form-panel-header">Abas do formulário</div>

            <div class="form-panel-body">
                <div class="row-start row-space">
                    <button type="button" class="btn-small" @click="adicionarAba">
                        Nova aba
                    </button>

                    <button type="button" class="btn-small" @click="renomearAbaAtual">
                        Renomear
                    </button>
                    

                    <div class="doc-tabs">
                        <button
                            v-for="aba in lsAbas"
                            :key="aba.cdaba"
                            type="button"
                            class="doc-tab"
                            :class="{ active: aba.cdaba === cdAbaAtiva }"
                            @click="cdAbaAtiva = aba.cdaba"
                        >
                            {{ aba.cdaba }}
                            <small>{{ qtdeItensPorAba(aba.cdaba) }}</small>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        

        <!-- ITENS DO MODELO -->
        <div class="form-panel row-space">
            <div class="form-panel-header">
                Itens do modelo - {{ cdAbaAtiva }}
            </div>

            <div class="form-panel-body">
                <div class="doc-toolbar">
                    <div class="doc-toolbar-left">
                        <button type="button" class="btn-small" @click="adicionarItem(null, 'GROUP')">
                            + Grupo
                        </button>

                        <button type="button" class="btn-small" @click="adicionarItem(null, 'TABLE')">
                            + Tabela
                        </button>

                        <button type="button" class="btn-small" @click="adicionarItem(null, 'SESSION')">
                            + Sessão
                        </button>

                        <button type="button" class="btn-small" @click="adicionarItem(null, 'ITEM')">
                            + Item
                        </button>
                    </div>

                    <div class="doc-toolbar-info">
                        Alterados: {{ totalAlterados }} |
                        Excluídos: {{ lsItensExcluidos.length }}
                    </div>
                </div>

                <div v-if="itensDaAba.length === 0" class="info-empty">
                    Nenhum item configurado para esta aba.
                </div>

                <div v-else class="doc-item-list">
                    <template v-for="item in itensRaizDaAba" :key="item._uid">
                        <div
                            class="doc-config-card"
                            :class="cardClass(item)"
                        >
                            <ItemCardHeader
                                :item="item"
                                @add-child="adicionarItem(item, 'ITEM')"
                                @add-below="adicionarItemAbaixo(item)"
                                @remove="removerItem(item)"
                            />

                            <ItemConfigFields
                                :item="item"
                                :grupos="gruposDaAba"
                                :is-child="false"
                                @changed="marcarAlterado"
                                @tp-item-change="onTpItemChange"
                                @resposta-change="onRespostaChange"
                            />
                        </div>

                        <div
                            v-if="filhosDoItem(item).length"
                            class="doc-config-children"
                        >
                            <div
                                v-for="filho in filhosDoItem(item)"
                                :key="filho._uid"
                                class="doc-config-card doc-config-card-child"
                                :class="{ 'doc-config-card-changed': filho._changed }"
                            >
                                <ItemCardHeader
                                    :item="filho"
                                    child
                                    @add-below="adicionarItemAbaixo(filho, item)"
                                    @remove="removerItem(filho)"
                                />

                                <ItemConfigFields
                                    :item="filho"
                                    :grupos="gruposDaAba"
                                    is-child
                                    @changed="marcarAlterado"
                                    @tp-item-change="onTpItemChange"
                                    @resposta-change="onRespostaChange"
                                />
                            </div>
                        </div>
                    </template>
                </div>

                <div class="doc-toolbar doc-toolbar-bottom">
                    <div class="doc-toolbar-left">
                        <button type="button" class="btn-small" @click="adicionarItem(null, 'GROUP')">
                            + Grupo
                        </button>

                        <button type="button" class="btn-small" @click="adicionarItem(null, 'TABLE')">
                            + Tabela
                        </button>

                        <button type="button" class="btn-small" @click="adicionarItem(null, 'SESSION')">
                            + Sessão
                        </button>

                        <button type="button" class="btn-small" @click="adicionarItem(null, 'ITEM')">
                            + Item
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    
    <div class="row-end row-space">
        <button type="button" class="btn-confirm" @click="salvarDados">
            Salvar
        </button>

        <button type="button" class="btn-cancel" @click="closeForm">
            Cancelar
        </button>
    </div>

    <!-- mantenho só para conferência durante desenvolvimento -->
    <div v-if="debug" class="json-debug">
        {{ payloadPreview }}
    </div>

    

    <ModalVincularPerfilTpDoc
        v-if="showModalPerfil"
        :idDocModelo="objEdicao.id"
        :nmDocModelo="objEdicao.nmepdocmodelo"
        @close="showModalPerfil = false"
    />
</template>

<script setup>
import { Api } from '@/funcoes/apiExport';
import { criarEpDocModelo } from '@/models/epDocModelo';
import { computed, defineComponent, h, onMounted, ref } from 'vue';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import { Validar } from '@/funcoes/validacoes';
import EpMenuDocSelect from '@/components/selects/EpMenuDocSelect.vue';
import ModalVincularPerfilTpDoc from '@/components/modals/ModalVincularPerfilTpDoc.vue';

const emit = defineEmits(['close', 'save']);
const props = defineProps({
    idEdicao: {
        type: Number,
        default: 0
    }
});

const showModalPerfil = ref(false);

const debug = ref(false);
const isLoading = ref(false);
const lsItem = ref([]);
const lsItensExcluidos = ref([]);
const msgAlerta = ref(null);
const objEdicao = ref(criarEpDocModelo());
const cdAbaAtiva = ref('GERAL');

const TP_ITEM = ['GROUP', 'SESSION', 'TABLE', 'ITEM'];
const TP_ITEM_COM_FILHOS = ['GROUP', 'TABLE'];
const TP_RESPOSTA = ['FIELD', 'MEMO', 'SELECT', 'CHECK', 'CHECK_SN', 'RADIO_GROUP'];

function closeForm() {
    emit('close');
}

function novoUid() {
    return `${Date.now()}_${Math.random().toString(16).slice(2)}`;
}

function normalizarSN(valor, padrao = 'N') {
    return valor === 'S' || valor === 'N' ? valor : padrao;
}

function prepararItem(item) {
    return {
        ...item,

        cdaba: item.cdaba || 'GERAL',
        cdlinha: item.cdlinha || null,

        ckinformacoes: normalizarSN(item.ckinformacoes),
        ckobrigatorio: normalizarSN(item.ckobrigatorio),

        // Mantido no objeto apenas por compatibilidade com registros antigos/API.
        // A tela nova não edita mais esse campo.
        ckmultiplas: normalizarSN(item.ckmultiplas),

        _uid: item.id > 0 ? `id_${item.id}` : novoUid(),
        _changed: false,
        _new: !(item.id > 0),
        _deleted: false,

        // usado quando um grupo ainda não tem ID real do banco
        _idpai_tmp: item._idpai_tmp || null
    };
}

const lsAbas = computed(() => {
    const set = new Set(['GERAL']);

    lsItem.value
        .filter(item => !item._deleted)
        .forEach(item => set.add(item.cdaba || 'GERAL'));

    return Array.from(set)
        .sort((a, b) => a.localeCompare(b))
        .map(cdaba => ({ cdaba }));
});

const itensOrdenados = computed(() => {
    return [...lsItem.value].sort((a, b) => {
        const ordemA = Number(a.ordem ?? 0);
        const ordemB = Number(b.ordem ?? 0);

        if (ordemA !== ordemB) return ordemA - ordemB;

        return String(a.cditem || '').localeCompare(String(b.cditem || ''));
    });
});

const itensDaAba = computed(() => {
    return itensOrdenados.value
        .filter(item => !item._deleted)
        .filter(item => (item.cdaba || 'GERAL') === cdAbaAtiva.value);
});

const itensRaizDaAba = computed(() => {
    return itensDaAba.value.filter(item => !item.idpai && !item._idpai_tmp);
});

const gruposDaAba = computed(() => {
    return itensDaAba.value.filter(item => TP_ITEM_COM_FILHOS.includes(item.tpitem));
});

const totalAlterados = computed(() => {
    return lsItem.value.filter(item => item._changed || item._new).length;
});

const payloadPreview = computed(() => {
    return {
        alterados: itensAlteradosParaSalvar(),
        excluidos: lsItensExcluidos.value.map(item => item.id).filter(id => id > 0)
    };
});

function qtdeItensPorAba(cdaba) {
    return lsItem.value
        .filter(item => !item._deleted)
        .filter(item => (item.cdaba || 'GERAL') === cdaba)
        .length;
}

function cardClass(item) {
    return {
        'doc-config-card-group': item.tpitem === 'GROUP',
        'doc-config-card-session': item.tpitem === 'SESSION',
        'doc-config-card-table': item.tpitem === 'TABLE',
        'doc-config-card-changed': item._changed
    };
}

function filhosDoItem(itemPai) {
    return itensDaAba.value
        .filter(item => {
            if (itemPai.id > 0 && Number(item.idpai || 0) === Number(itemPai.id)) return true;
            if (item._idpai_tmp && item._idpai_tmp === itemPai._uid) return true;
            return false;
        })
        .sort((a, b) => Number(a.ordem ?? 0) - Number(b.ordem ?? 0));
}

function adicionarAba() {
    let contador = lsAbas.value.length + 1;
    let cdaba = `ABA${contador}`;

    while (lsAbas.value.some(aba => aba.cdaba === cdaba)) {
        contador++;
        cdaba = `ABA${contador}`;
    }

    cdAbaAtiva.value = cdaba;
}

function renomearAbaAtual() {
    const novoNome = window.prompt('Informe o novo código da aba:', cdAbaAtiva.value);
    if (!novoNome) return;

    const cdabaNovo = novoNome.trim().toUpperCase();
    if (!cdabaNovo) return;

    const cdabaAntigo = cdAbaAtiva.value;

    lsItem.value.forEach(item => {
        if ((item.cdaba || 'GERAL') === cdabaAntigo) {
            item.cdaba = cdabaNovo;
            marcarAlterado(item);
        }
    });

    cdAbaAtiva.value = cdabaNovo;
}

function proximaOrdem(itemPai = null) {
    const lista = itemPai ? filhosDoItem(itemPai) : itensRaizDaAba.value;

    if (!lista.length) return 1;

    return Math.max(...lista.map(item => Number(item.ordem || 0))) + 1;
}

function criarNovoItem(itemPai = null, tpitem = 'ITEM') {
    const isItem = tpitem === 'ITEM';

    return prepararItem({
        id: 0,
        idepdocmodelo: objEdicao.value.id || 0,

        idpai: itemPai?.id > 0 ? itemPai.id : null,
        _idpai_tmp: itemPai?.id > 0 ? null : itemPai?._uid || null,

        cdaba: itemPai?.cdaba || cdAbaAtiva.value || 'GERAL',
        tpitem,
        cditem: '',
        cdsessao: null,
        ordem: proximaOrdem(itemPai),
        cdlinha: null,

        tpresposta: isItem ? 'FIELD' : null,
        tpfield: isItem ? 'TEXTO' : null,
        textlength: isItem ? 200 : null,

        nmcaption: '',
        opcoes: null,
        opcoes_ckobs: null,
        opcoes_gera_rac: null,
        cditem_nmitem_rac: null,
        cdgrupo_opcoes: null,
        cditem_depende: null,

        ckinformacoes: 'N',
        ckmultiplas: 'N',
        ckobrigatorio: isItem ? 'S' : 'N',

        idlogin: globalStore.idlogin
    });
}

function adicionarItem(itemPai = null, tpitem = 'ITEM') {
    if (!TP_ITEM.includes(tpitem)) return;

    const novo = criarNovoItem(itemPai, tpitem);
    lsItem.value.push(novo);
}

function adicionarItemAbaixo(itemReferencia, itemPai = null) {
    const novo = criarNovoItem(itemPai, 'ITEM');

    novo.ordem = Number(itemReferencia.ordem || 0) + 1;
    novo.cdlinha = itemReferencia.cdlinha || null;

    lsItem.value
        .filter(item => !item._deleted)
        .filter(item => (item.cdaba || 'GERAL') === (itemReferencia.cdaba || 'GERAL'))
        .filter(item => Number(item.ordem || 0) >= novo.ordem)
        .forEach(item => {
            item.ordem = Number(item.ordem || 0) + 1;
            marcarAlterado(item);
        });

    lsItem.value.push(novo);
}

function removerItem(item) {
    if (!window.confirm('Confirma a exclusão deste item?')) return;

    const filhos = filhosDoItem(item);

    if (item.id > 0) {
        item._deleted = true;
        item._changed = true;
        lsItensExcluidos.value.push(item);
    } else {
        lsItem.value = lsItem.value.filter(i => i._uid !== item._uid);
    }

    filhos.forEach(filho => removerItemSemConfirmar(filho));
}

function removerItemSemConfirmar(item) {
    if (item.id > 0) {
        item._deleted = true;
        item._changed = true;
        lsItensExcluidos.value.push(item);
    } else {
        lsItem.value = lsItem.value.filter(i => i._uid !== item._uid);
    }
}

function marcarAlterado(payload) {
    const item = payload?.item || payload;

    if (payload?.campo) {
        item[payload.campo] = payload.value;
    }

    item._changed = true;
    item.idlogin = globalStore.idlogin;
}

function usaOpcoes(item) {
    if (TP_ITEM_COM_FILHOS.includes(item.tpitem)) return true;

    return ['SELECT', 'CHECK', 'RADIO_GROUP'].includes(item.tpresposta);
}

function onTpItemChange(item) {
    if (!TP_ITEM.includes(item.tpitem)) {
        item.tpitem = 'ITEM';
    }

    if (item.tpitem !== 'ITEM') {
        item.tpresposta = null;
        item.tpfield = null;
        item.textlength = null;
        item.ckobrigatorio = 'N';
        item.cdlinha = null;

        if (item.tpitem === 'GROUP' && !item.opcoes) {
            item.opcoes = 'C;NC;P;NA';
        }

        if (item.tpitem === 'TABLE' && !item.opcoes) {
            item.opcoes = 'C;NC;P;NA';
        }

        if (item.tpitem === 'SESSION') {
            item.opcoes = null;
            item.opcoes_ckobs = null;
            item.opcoes_gera_rac = null;
            item.cditem_nmitem_rac = null;
            item.ckinformacoes = 'N';
        }
    } else {
        item.tpresposta = item.tpresposta || 'FIELD';
        item.tpfield = item.tpresposta === 'FIELD' ? (item.tpfield || 'TEXTO') : null;
        item.ckobrigatorio = item.ckobrigatorio || 'S';
    }

    marcarAlterado(item);
}

function onRespostaChange(item) {
    if (!TP_RESPOSTA.includes(item.tpresposta)) {
        item.tpresposta = 'FIELD';
    }

    if (item.tpresposta !== 'FIELD') {
        item.tpfield = null;
        item.textlength = null;
        item.cdlinha = null;
    } else {
        item.tpfield = item.tpfield || 'TEXTO';
        item.textlength = item.textlength || 200;
    }

    if (!usaOpcoes(item)) {
        item.opcoes = null;
        item.opcoes_ckobs = null;
        item.opcoes_gera_rac = null;
        item.cditem_nmitem_rac = null;
    }

    // regra nova:
    // CHECK = múltipla escolha por natureza
    // SELECT/RADIO_GROUP = escolha única
    item.ckmultiplas = item.tpresposta === 'CHECK' ? 'S' : 'N';

    marcarAlterado(item);
}

function itensAlteradosParaSalvar() {
    return lsItem.value
        .filter(item => item._changed || item._new)
        .map(item => limparItemParaApi(item));
}

function limparItemParaApi(item) {
    const itemApi = { ...item };

    delete itemApi._uid;
    delete itemApi._changed;
    delete itemApi._new;
    delete itemApi._deleted;
    delete itemApi._idpai_tmp;

    itemApi.cdaba = itemApi.cdaba || 'GERAL';
    itemApi.cdlinha = itemApi.cdlinha || null;
    itemApi.idlogin = globalStore.idlogin;

    if (itemApi.tpitem !== 'ITEM') {
        itemApi.tpresposta = null;
        itemApi.tpfield = null;
        itemApi.textlength = null;
        itemApi.cdlinha = null;
    }

    if (itemApi.tpitem === 'SESSION') {
        itemApi.opcoes = null;
        itemApi.opcoes_ckobs = null;
        itemApi.opcoes_gera_rac = null;
        itemApi.cditem_nmitem_rac = null;
        itemApi.ckinformacoes = 'N';
        itemApi.ckobrigatorio = 'N';
    }

    if (itemApi.tpitem === 'TABLE') {
        itemApi.ckobrigatorio = 'N';
    }

    if (itemApi.tpresposta === 'CHECK') {
        itemApi.ckmultiplas = 'S';
    } else {
        itemApi.ckmultiplas = 'N';
    }

    return itemApi;
}


async function salvarItensAlterados() {
    const excluidos = lsItensExcluidos.value
        .map(item => item.id)
        .filter(id => id > 0);

    // Ajuste os endpoints abaixo conforme tua API.
    // Mantive separado para facilitar o caso dos itens-pai novos com filhos.
    for (const id of excluidos) {
        await Api.genericDelete?.('/cad/epdocmodelo/item', { id });
    }

    const itensRaiz = lsItem.value
        .filter(item => !item._deleted)
        .filter(item => item._changed || item._new)
        .filter(item => !item.idpai && !item._idpai_tmp)
        .sort((a, b) => Number(a.ordem || 0) - Number(b.ordem || 0));

    for (const item of itensRaiz) {
        const itemSalvo = await Api.genericPut('/cad/epdocmodelo/item', limparItemParaApi(item));
        const uidTemporarioPai = item._uid;

        if (item.id === 0 && itemSalvo?.id) {
            item.id = itemSalvo.id;
            // item._uid = `id_${item.id}`;
        }

        if (TP_ITEM_COM_FILHOS.includes(item.tpitem)) {
            const filhos = lsItem.value
                .filter(filho => !filho._deleted)
                .filter(filho => filho._idpai_tmp === uidTemporarioPai);

            for (const filho of filhos) {
                filho.idpai = item.id;
                filho._idpai_tmp = null;

                const filhoSalvo = await Api.genericPut('/cad/epdocmodelo/item', limparItemParaApi(filho));

                if (filho.id === 0 && filhoSalvo?.id) {
                    filho.id = filhoSalvo.id;
                    filho._uid = `id_${filho.id}`;
                }

                filho._new = false;
                filho._changed = false;
            }
        }

        if (item.id > 0) {
            item._uid = `id_${item.id}`;
        }

        item._new = false;
        item._changed = false;
    }

    const filhosAlteradosDeItensPaiExistentes = lsItem.value
        .filter(item => !item._deleted)
        .filter(item => item._changed || item._new)
        .filter(item => item.idpai || item._idpai_tmp)
        .sort((a, b) => Number(a.ordem || 0) - Number(b.ordem || 0));

    for (const filho of filhosAlteradosDeItensPaiExistentes) {
        const filhoSalvo = await Api.genericPut('/cad/epdocmodelo/item', limparItemParaApi(filho));

        if (filho.id === 0 && filhoSalvo?.id) {
            filho.id = filhoSalvo.id;
            filho._uid = `id_${filho.id}`;
        }

        filho._new = false;
        filho._changed = false;
    }

    lsItensExcluidos.value = [];
}

async function lerDados() {
    try {
        isLoading.value = true;
        msgAlerta.value = null;

        if (props.idEdicao > 0) {
            const req = await Api.getCadastroById('epdocmodelo', props.idEdicao);
            Object.assign(objEdicao.value, req[0]);

            const reqItem = await Api.genericGet('/cad/epdocmodelo/item/from/modelo', {
                id: props.idEdicao
            });

            lsItem.value = reqItem.map(prepararItem);

            const primeiraAba = lsAbas.value[0]?.cdaba;
            cdAbaAtiva.value = primeiraAba || 'GERAL';
        } else {
            objEdicao.value.idep = globalStore.idep;
            cdAbaAtiva.value = 'GERAL';
        }

        objEdicao.value.idlogin = globalStore.idlogin;
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: Não foi possível acessar dados do servidor: "${error.message}"`;
    } finally {
        isLoading.value = false;
    }
}

async function salvarDados() {
    msgAlerta.value = validarDados();
    if (msgAlerta.value) return;

    try {
        isLoading.value = true;

        const response = await Api.genericPut('/cad/epdocmodelo', objEdicao.value);

        if (response.bolok === 1) {
            if (!objEdicao.value.id && response.id) {
                objEdicao.value.id = response.id;
            }

            await salvarItensAlterados();

            emit('save');
            emit('close');
        } else {
            msgAlerta.value = response.erro;
        }
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}

function validarDados() {
    let r = Validar.texto(objEdicao.value.nmepdocmodelo, 'Informe o nome do modelo');
    if (!r.ok) return r.msg;

    const itensValidos = lsItem.value.filter(item => !item._deleted);

    for (const item of itensValidos) {
        if (!TP_ITEM.includes(item.tpitem)) {
            return `Item "${item.cditem || item.nmcaption || 'sem código'}" possui tipo inválido.`;
        }

        if (!item.cdaba) {
            return `Informe a aba do item "${item.cditem || item.nmcaption || 'sem código'}".`;
        }

        if (!item.ordem && item.ordem !== 0) {
            return `Informe a ordem do item "${item.cditem || item.nmcaption || 'sem código'}".`;
        }

        if (!item.nmcaption) {
            return `Informe a descrição do item "${item.cditem || 'sem código'}".`;
        }

        if (item.tpitem === 'ITEM' && !item.tpresposta) {
            return `Informe o tipo de resposta do item "${item.cditem || item.nmcaption}".`;
        }

        if (item.tpitem === 'ITEM' && item.tpresposta === 'FIELD' && !item.tpfield) {
            return `Informe o tipo de campo do item "${item.cditem || item.nmcaption}".`;
        }

        // if (usaOpcoes(item) && !item.opcoes && item.tpresposta !== 'RADIO_GROUP') {
        //     return `Informe as opções do item "${item.cditem || item.nmcaption}".`;
        // }
    }

    return null;
}

onMounted(lerDados);


/**
 * Subcomponente local para evitar duplicar o cabeçalho dos cards.
 */
const ItemCardHeader = defineComponent({
    name: 'ItemCardHeader',
    props: {
        item: {
            type: Object,
            required: true
        },
        child: {
            type: Boolean,
            default: false
        }
    },
    emits: ['add-child', 'add-below', 'remove'],
    setup(props, { emit }) {
        return () => h('div', { class: 'doc-config-header' }, [
            h('div', { class: 'doc-config-title' }, [
                h('strong', props.item.cditem || (props.child ? 'Novo filho' : 'Novo item')),
                h('span', props.child ? 'FILHO' : props.item.tpitem),
                props.item._new ? h('small', { class: 'new' }, 'NOVO') : null,
                props.item._changed ? h('small', null, 'ALTERADO') : null
            ]),

            h('div', { class: 'doc-config-actions' }, [
                TP_ITEM_COM_FILHOS.includes(props.item.tpitem)
                    ? h('button', {
                        type: 'button',
                        class: 'btn-icon--add',
                        title: props.item.tpitem === 'TABLE' ? 'Adicionar item à tabela' : 'Adicionar filho ao grupo',
                        onClick: () => emit('add-child')
                    })
                    : null,

                h('button', {
                    type: 'button',
                    class: 'btn-icon--add',
                    title: 'Adicionar item abaixo',
                    onClick: () => emit('add-below')
                }),

                h('button', {
                    type: 'button',
                    class: 'btn-icon--trash',
                    title: 'Excluir item',
                    onClick: () => emit('remove')
                })
            ])
        ]);
    }
});


/**
 * Subcomponente local para os campos de configuração.
 * Mantive no mesmo arquivo para facilitar colar a tela completa.
 */
const ItemConfigFields = defineComponent({
    name: 'ItemConfigFields',
    props: {
        item: {
            type: Object,
            required: true
        },
        grupos: {
            type: Array,
            default: () => []
        },
        isChild: {
            type: Boolean,
            default: false
        }
    },
    emits: ['changed', 'tp-item-change', 'resposta-change'],
    setup(props, { emit }) {
        function changed() {
            emit('changed', props.item);
        }

        function tpItemChange() {
            emit('tp-item-change', props.item);
        }

        function respostaChange() {
            emit('resposta-change', props.item);
        }

        function bindInput(campo, modifiers = {}) {
            return {
                value: props.item[campo] ?? '',
                onInput: event => {
                    let value = event.target.value;

                    if (modifiers.number) {
                        value = value === '' ? null : Number(value);
                    }

                    if (modifiers.upper) {
                        value = String(value || '').toUpperCase();
                    }

                    emit('changed', {
                        item: props.item,
                        campo,
                        value: value || null
                    });
                }
            };
        }

        function bindSelect(campo, onChange = null) {
            return {
                value: props.item[campo] ?? '',
                onChange: event => {
                    emit('changed', {
                        item: props.item,
                        campo,
                        value: event.target.value || null
                    });

                    if (onChange) {
                        onChange();
                    }
                }
            };
        }

        function label(texto) {
            return h('label', { class: 'label-caption' }, texto);
        }

        function inputBox(classe, labelTexto, campo, attrs = {}, modifiers = {}) {
            return h('div', { class: classe }, [
                label(labelTexto),
                h('input', {
                    type: attrs.type || 'text',
                    maxlength: attrs.maxlength,
                    class: attrs.class,
                    disabled: attrs.disabled,
                    ...bindInput(campo, modifiers)
                })
            ]);
        }

        function selectBox(classe, labelTexto, campo, options, attrs = {}, onChange = changed) {
            return h('div', { class: classe }, [
                label(labelTexto),
                h('select', {
                    disabled: attrs.disabled,
                    ...bindSelect(campo, onChange)
                }, options.map(opt => {
                    if (typeof opt === 'string') {
                        return h('option', { value: opt }, opt);
                    }

                    return h('option', {
                        value: opt.value,
                        disabled: opt.disabled
                    }, opt.label);
                }))
            ]);
        }

        return () => {
            const item = props.item;
            const isItem = item.tpitem === 'ITEM';
            const isField = isItem && item.tpresposta === 'FIELD';
            const hasOptions = TP_ITEM_COM_FILHOS.includes(item.tpitem) || ['SELECT', 'CHECK', 'RADIO_GROUP'].includes(item.tpresposta);

            return h('div', [
                h('div', { class: 'row row-space' }, [
                    !props.isChild
                        ? selectBox('form-item-char15', 'TP Item', 'tpitem', [
                            'GROUP',
                            'TABLE',
                            'SESSION',
                            'ITEM'
                        ], {}, tpItemChange)
                        : selectBox('form-item-char15', 'TP Item', 'tpitem', [
                            'SESSION',
                            'ITEM'
                        ], {}, tpItemChange),

                    inputBox('form-item', 'Código', 'cditem', {
                        maxlength: 50
                    }),

                    inputBox('form-item-char05', 'Ordem', 'ordem', {
                        class: 'input-right'
                    }, { number: true }),

                    inputBox('form-item-char15', 'Aba', 'cdaba', {
                        maxlength: 20
                    }, { upper: true }),

                    inputBox('form-item-char05', 'Linha', 'cdlinha', {
                        class: 'input-right',
                        maxlength: 3,
                    }, { upper: true }),

                    selectBox('form-item-char15', 'Resposta', 'tpresposta', [
                        { value: '', label: 'Nenhuma' },
                        { value: 'FIELD', label: 'FIELD' },
                        { value: 'MEMO', label: 'MEMO' },
                        { value: 'SELECT', label: 'SELECT' },
                        { value: 'CHECK', label: 'CHECK' },
                        { value: 'CHECK_SN', label: 'CHECK_SN' },
                        { value: 'RADIO_GROUP', label: 'RADIO_GROUP' }
                    ], {
                        disabled: !isItem
                    }, respostaChange),

                    selectBox('form-item-char15', 'Tipo Campo', 'tpfield', [
                        { value: '', label: 'Nenhum' },
                        { value: 'TEXTO', label: 'TEXTO' },
                        { value: 'CPF', label: 'CPF' },
                        { value: 'CNPJ', label: 'CNPJ' },
                        { value: 'CEP', label: 'CEP' },
                        { value: 'FONE', label: 'FONE' },
                        { value: 'DATA', label: 'DATA' },
                        { value: 'NUMERO', label: 'NUMERO' }
                    ], {
                        disabled: !isField
                    }),

                    inputBox('form-item-char10', 'Tamanho', 'textlength', {
                        class: 'input-right',
                        disabled: !isField && item.tpresposta !== 'MEMO'
                    }, { number: true }),

                    selectBox('form-item-char15', 'Info', 'ckinformacoes', [
                        { value: 'S', label: 'Sim' },
                        { value: 'N', label: 'Não' }
                    ]),

                    selectBox('form-item-char15', 'Obrigatório', 'ckobrigatorio', [
                        { value: 'S', label: 'Sim' },
                        { value: 'N', label: 'Não' }
                    ], {
                        disabled: !isItem
                    })
                ]),

                h('div', { class: 'row row-space' }, [
                    h('div', { class: 'form-item' }, [
                        label('Descrição / Caption'),
                        h('textarea', {
                            rows: 2,
                            maxlength: 3000,
                            value: item.nmcaption || '',
                            onInput: event => {
                                emit('changed', {
                                    item,
                                    campo: 'nmcaption',
                                    value: event.target.value || null
                                });
                            }
                        })
                    ])
                ]),

                h('div', { class: 'row row-space' }, [
                    h('div', { class: 'form-item' }, [
                        label('Opções'),
                        h('input', {
                            type: 'text',
                            disabled: !hasOptions,
                            value: item.opcoes || '',
                            onInput: event => {
                                emit('changed', {
                                    item,
                                    campo: 'opcoes',
                                    value: event.target.value || null
                                });
                            }
                        })
                    ]),

                    h('div', { class: 'form-item' }, [
                        label('Opções que exigem observação'),
                        h('input', {
                            type: 'text',
                            disabled: !hasOptions,
                            value: item.opcoes_ckobs || '',
                            onInput: event => {
                                emit('changed', {
                                    item,
                                    campo: 'opcoes_ckobs',
                                    value: event.target.value || null
                                });
                            }
                        })
                    ]),

                    h('div', { class: 'form-item' }, [
                        label('Opções que geram RAC'),
                        h('input', {
                            type: 'text',
                            disabled: !hasOptions,
                            value: item.opcoes_gera_rac || '',
                            onInput: event => {
                                emit('changed', {
                                    item,
                                    campo: 'opcoes_gera_rac',
                                    value: event.target.value || null
                                });
                            }
                        })
                    ]),

                    h('div', { class: 'form-item-char20' }, [
                        label('CDITEM Titulo RAC'),
                        h('input', {
                            type: 'text',
                            disabled: !hasOptions,
                            value: item.cditem_nmitem_rac || '',
                            onInput: event => {
                                emit('changed', {
                                    item,
                                    campo: 'cditem_nmitem_rac',
                                    value: event.target.value || null
                                });
                            }
                        })
                    ]),

                    h('div', { class: 'form-item-char30' }, [
                        label('Grupo Tabela de Opções'),
                        h('input', {
                            type: 'text',
                            disabled: !hasOptions,
                            value: item.cdgrupo_opcoes || '',
                            onInput: event => {
                                emit('changed', {
                                    item,
                                    campo: 'cdgrupo_opcoes',
                                    value: event.target.value || null
                                });
                            }
                        })
                    ]),

                    h('div', { class: 'form-item-char20' }, [
                        label('CDITEM Dependência'),
                        h('input', {
                            type: 'text',
                            disabled: !hasOptions,
                            value: item.cditem_depende || '',
                            onInput: event => {
                                emit('changed', {
                                    item,
                                    campo: 'cditem_depende',
                                    value: event.target.value || null
                                });
                            }
                        })
                    ]),
                ])
            ]);
        };
    }
});
</script>

<style scoped>
.doc-tabs {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
}

.doc-tab {
    width: auto;
    min-width: 90px;
    padding: 6px 10px;
    background: #f2f2f2;
    border: 1px solid #bbb;
    color: #333;
}

.doc-tab small {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 20px;
    margin-left: 5px;
    padding: 1px 5px;
    border-radius: 10px;
    background: #d9e4e2;
    color: #1f2937;
}

.doc-tab.active {
    background: #4a827c;
    color: #fff;
    border-color: #25413e;
}

.doc-tab.active small {
    background: #fff;
    color: #25413e;
}

.doc-toolbar {
    position: sticky;
    top: 0;
    z-index: 20;

    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;

    margin: -5px -5px 8px -5px;
    padding: 6px;

    background: #f8fafc;
    border-bottom: 1px solid #cbd5e1;
}

.doc-toolbar-bottom {
    position: static;
    margin: 8px -5px -5px -5px;
    border-top: 1px solid #cbd5e1;
    border-bottom: none;
}

.doc-toolbar-left {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.doc-toolbar-info {
    font-size: 12px;
    color: #475569;
}

.doc-item-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.doc-config-card {
    border: 1px solid #cbd5e1;
    border-radius: 6px;
    background: #fff;
    padding: 8px;
}

.doc-config-card-group {
    border-left: 6px solid #4a827c;
    background: #f8ffff;
}

.doc-config-card-session {
    border-left: 6px solid #64748b;
    background: #f8fafc;
}

.doc-config-card-table {
    border-left: 6px solid #7c3aed;
    background: #fbfaff;
}

.doc-config-card-child {
    margin-left: 28px;
    border-left: 4px solid #94a3b8;
}

.doc-config-card-changed {
    box-shadow: 0 0 0 2px #f59e0b inset;
}

.doc-config-children {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-top: -2px;
    margin-bottom: 8px;
}

.doc-config-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 6px;
}

.doc-config-title {
    display: flex;
    align-items: center;
    gap: 8px;
    text-align: left;
}

.doc-config-title span {
    font-size: 12px;
    padding: 2px 6px;
    border-radius: 10px;
    background: #e2e8f0;
    color: #334155;
}

.doc-config-title small {
    font-size: 11px;
    color: #b45309;
    font-weight: bold;
}

.doc-config-title small.new {
    color: #047857;
}

.doc-config-actions {
    display: flex;
    align-items: center;
    gap: 8px;
}

.doc-config-actions button {
    width: 18px;
}

.doc-mini-button {
    width: 22px !important;
    height: 22px;
    padding: 0;
    border-radius: 50%;
    background: #eff6f5;
    box-shadow: 0 0 0 1px #25413e inset;
    color: #25413e;
    font-weight: bold;
}

.doc-mini-button:hover {
    background: #aed0cd;
    color: #0e251b;
}

@media (max-width: 900px) {
    .doc-config-card-child {
        margin-left: 10px;
    }

    .doc-toolbar {
        align-items: flex-start;
        flex-direction: column;
    }
}
</style>
